<fieldset class="d-flex justify-content-end align-items-center" *ngIf="Pagination" [disabled]="Loading">
  <small class="text-muted me-2">Items per page:</small>
  <div class="col-2">
    <select [disabled]='!HasData' (change)='setRows($event)' name="itemsperpage" id="itemsperpage"
      class="form-select form-select-sm" [(ngModel)]="Pagination.ItemsPerPage">
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="50">50</option>
      <option value="100">100</option>
      <option value="200">200</option>
    </select>
  </div>
  <ng-container *ngIf="Pagination?.ShowAll">
    <small *ngIf="Pagination.ShowAll" class="text-muted mx-5">Found: {{ Pagination.NumItems }}</small>
  </ng-container>
  <ng-container *ngIf="Pagination && !Pagination?.ShowAll">
    <small class="text-muted mx-3">
      <ng-container *ngIf="HasData && !Loading">
        {{ (Pagination.Page + 1) * Pagination.ItemsPerPage - Pagination.ItemsPerPage + 1}} -
        <ng-container *ngIf="Pagination.Page + 1 !== Pagination.NumPages; else elseTemplate">
          {{ (Pagination.Page + 1) * Pagination.ItemsPerPage }}
        </ng-container>
        <ng-template #elseTemplate>
          {{ Pagination.NumItems }}
        </ng-template>
        of {{ Pagination.NumItems }}
      </ng-container>
      <ng-container *ngIf="!HasData && !Loading">
        No data found
      </ng-container>
      <button class="btn btn-sm btn-primary w-100" type="button" disabled *ngIf="Loading">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </button>
    </small>

    <div class="btn-group">
      <button (click)="decreasePagination()" [disabled]='Pagination.Page === 0' class="btn btn-primary btn-sm me-1">
        <i class="bi bi-caret-left-fill"></i> </button>
      <button (click)="increasePagination()"
        [disabled]='Pagination.Page + 1 === Pagination.NumPages || !Pagination.NumPages' class="btn btn-primary btn-sm">
        <i class="bi bi-caret-right-fill"></i>
      </button>
    </div>
  </ng-container>
</fieldset>
